<template>
    <v-dialog v-model="dialog" max-width="800px">
        <v-card>
            <v-toolbar title="Enviar solicitud a realizar" class="modal-header"></v-toolbar>
            
            <v-card-text class="pt-6">
                <!-- Información del efector actual -->
                <v-alert 
                    type="info" 
                    variant="tonal"
                    class="mb-4"
                >
                    <div class="d-flex align-center">
                        <div>
                            <p class="mb-1"><strong>Efector actual de la solicitud:</strong></p>
                            <p class="mb-0">{{ efectorActual }}</p>
                        </div>
                    </div>
                </v-alert>

                <!-- Selector de nuevo efector (solo se muestra si selecciona "otro") -->
                <v-expand-transition>
                    <div>
                        <v-divider class="mb-4"></v-divider>
                        <v-row>
                            <v-col cols="12" md="4">
                                <h4 class="my-text-black">Datos del profesional efector</h4>
                            </v-col>
                            <v-col cols="12" md="8">
                                <p text-h5 class="font-weight-light">Busque por nombre o matrícula</p>
                            </v-col>
                        </v-row>
                        
                        <v-autocomplete
                            required
                            class="asterisco mb-4"
                            :rules="obligatorio"
                            label="Matricula - Apellido y Nombre"
                            :items="profesionalesFacturador"
                            return-object
                            :item-title="itemTitlePrescriptor"
                            variant="solo"
                            v-model="profesionalEfector"
                            auto-select-first="true"
                            no-data-text="No se encontraron resultados"
                            :menu-props="{width: 200}"
                            @update:modelValue="onProfesionalChange"
                            :loading="cargandoEfector"
                        ></v-autocomplete>
                        
                        <EspecialidadOptions
                            ref="especialidadOptions"
                            :obligatorio="obligatorio"
                            :idProfesional="profesionalEfector ? profesionalEfector.id : null"
                            @especialidadSeleccionada="onEspecialidadChange($event)"
                        ></EspecialidadOptions>
                    </div>
                </v-expand-transition>
            </v-card-text>

            <v-card-actions class="justify-end pa-4">
                <v-btn
                    text="Cancelar"
                    variant="text"
                    @click="cerrarModal"
                ></v-btn>
                <v-btn
                    id="boton-verde"
                    text="Modificar Efector"
                    :disabled="!puedeEnviar"
                    :loading="enviando"
                    @click="modificarEfector"
                ></v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<style scoped src="../assets/general.css">
.my-text-black {
    color: #000000;
}

.asterisco::after {
    content: " *";
    color: red;
}

#boton-verde {
    background-color: #244125;
    color: white;
}
</style>

<script>
import EspecialidadOptions from './EspecialidadOptions.vue';

export default {
    name: 'ModalModificarEfector',
    components: {
        EspecialidadOptions
    },
    props: {
        modelValue: {
            type: Boolean,
            default: false
        },
        idSolicitud: {
            type: Number,
            required: true
        },
        efectorActual: {
            type: String,
            required: true
        },
        profesionalesFacturador: {
            type: Array,
            default: () => []
        },
        cargandoEfector: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            profesionalEfector: null,
            especialidadSeleccionada: null,
            enviando: false,
            obligatorio: [
                v => !!v || 'Este campo es obligatorio'
            ]
        };
    },
    computed: {
        dialog: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit('update:modelValue', value);
            }
        },
        puedeEnviar() {
            return this.profesionalEfector && this.especialidadSeleccionada;
        }
    },
    methods: {
        itemTitlePrescriptor(item) {
            if (!item) return '';
            if(item.matriculaProvincial){
                return `${item.matriculaProvincial} - ${item.apellidos} ${item.nombres}`;
            }
            else{
                return `${item.matriculaNacional} - ${item.apellidos} ${item.nombres}`;
            }
        },
        onProfesionalChange(){
            if(this.profesionalEfector){
                this.$refs.especialidadOptions.getEspecialidadesProfesional(this.profesionalEfector.id)
            }
        },
        onEspecialidadChange(especialidad) {
            this.especialidadSeleccionada = especialidad;
        },
        async modificarEfector() {
            this.enviando = true;
            
            const datos = {
                idSolicitud: this.idSolicitud,
                nuevoEfector: {
                    idProfesional: this.profesionalEfector.id,
                    idEspecialidad: this.especialidadSeleccionada.id
                }
            };
            this.$emit('enviar', datos);
            this.enviando = false;
        },
        cerrarModal() {
            this.resetearFormulario();
            this.dialog = false;
        },
        resetearFormulario() {
            this.profesionalEfector = null;
            this.especialidadSeleccionada = null;
        }
    },
    watch: {
        modelValue(newVal) {
            if (!newVal) {
                this.resetearFormulario();
            }
        }
    }
};
</script>